import { Component, computed, input } from '@angular/core';
import { SupplierLinkPipe } from '@web/shared/pipes/supplier-link.pipe';
import { isEmpty } from 'class-validator';
import { SupplierCodeTagComponent } from '../../supplier-code-tag.component';
import { SearchSupplierEntry } from '../interfaces/search-supplier-entry.interface';
import { DetailItem, SearchItemBaseComponent } from './search-item-base.component';
import { SearchStatusChipComponent } from './search-status-chip.component';

@Component({
  selector: 'app-search-supplier-item',
  imports: [SupplierCodeTagComponent, SupplierLinkPipe, SearchItemBaseComponent, SearchStatusChipComponent],
  template: `
    @let _item = item();

    <app-search-item-base
      icon="pi pi-id-card"
      color="text-soe-ocean-blue"
      [detailRouterLink]="_item | supplierLink"
      [detailItems]="detailItems()"
    >
      <ng-template #title>
        <div [innerHTML]="_item.businessName"></div>
      </ng-template>

      <ng-template #codeTag>
        <app-supplier-code-tag [supplier]="_item" [clickable]="false" />
      </ng-template>

      <ng-template #statusChip>
        @if (_item.statusName) {
          <app-search-status-chip
            [name]="_item.statusName"
            [backgroundColor]="_item.statusColor"
            [textColor]="_item.statusTextColor"
          />
        }
      </ng-template>
    </app-search-item-base>
  `,
})
export class SearchSupplierItemComponent {
  readonly item = input.required<SearchSupplierEntry>();

  readonly detailItems = computed<DetailItem[]>(() => {
    const item = this.item();

    return [
      {
        icon: 'pi pi-map-marker',
        content: `${item.address} ${item.streetNumber}, ${item.zipCode} ${item.city}, ${item.state}, ${item.country}`,
        isHtml: true,
      },
      {
        icon: 'pi pi-envelope',
        content: item.email,
        isHtml: true,
      },
      {
        icon: 'pi pi-phone',
        content: item.phoneNumber,
        isHtml: true,
      },
      {
        icon: 'pi pi-building-columns',
        content: item.vatCode,
        isHtml: true,
      },
    ].filter((v) => !isEmpty(v.content));
  });
}
